export const TestimonialsData = [

    {
        id: 1,
        customerName: "Sudha Pramod",
        testimonial: "It's a delight to use VB Dace products. We use VB Dace cutlery, it is beautifully designed keeping the user experience in mind. They are sturdy, with a smooth finish and sheen. Comes in a nice packaging.Would love to get their entire range sometime! Thanks Chef!"
    },
    {
        id: 2,
        customerName: "Brindha D",
        testimonial: "We recently purchased a multi-cooker and are thoroughly impressed with its design and premium quality. The rice drainer is too good. Worthy for money."
    },
    {
        id: 3,
        customerName: "Geeta C Mohan",
        testimonial: "Since the inception of VB Dace products, they have been an integral part of my kitchen. I possess a diverse collection including a kadai, milk pot, saucepan, knife, idli cooker, triply tope with lid, brass coffee dabara set, and multi-cooker. Without fail, each of these products has consistently delivered outstanding performance, enhancing my cooking experience while also adding aesthetic appeal to my kitchen. The quality of VB Dace products is truly top-notch."
    },
    {
        id: 4,
        customerName: " N. Aishwaraya Lakshmi ",
        testimonial: "The product Triply Tope with lid we bought and used for the month,it was good..so we planned to gift it to our relatives. So the product is good and I had a good experience with customer service. They reached me as soon as  possible as they can and cleared my doubts and made my requests fulfilled with full patience. I would suggest VB Dace products in future if anyone suggests to gift them or also to their home for regular cooking."
    },
]